import type { AsyncThunkApiConfig } from '@/store'

import { createAsyncThunk } from '@reduxjs/toolkit'

import { RejectError } from '../../typings'

/**
 * Delete geofences
 *
 * @private
 */
export const deleteGeofences = createAsyncThunk<
  // Return type of the geofenceIds creator
  void,
  // First argument to the geofenceIds creator
  string[],
  // thunk API
  AsyncThunkApiConfig<RejectError>
>('domain/geofence/delete', async (geofenceIds, thunkApi) => {
  try {
    const rpc = thunkApi.extra.domainProxy.getRpc()

    const result = await rpc('rpc/geofence/delete', {
      category: 'rpc',
      type: 'rpc/geofence/delete',
      geofenceIds,
    })

    if (result.type === 'rpc-failure') {
      return thunkApi.rejectWithValue({
        type: 'rpcFailure',
        message: result.errorMessage,
        error: result,
      })
    }
  } catch (error) {
    thunkApi.extra.journal.main(
      `Unknown error on {deleteGeofence}`,
      { tags: ['rpc', 'geofence'], info: geofenceIds },
      'error',
    )
    return thunkApi.rejectWithValue({
      type: 'unknown',
      message: `Delete geofence failed`,
      error,
    })
  }
})
